export default __webpack_public_path__ + "static/media/PostgreSQL-WindowsTaskScheduler-CreateBasicTaskWizard01.28eea13f.png";